import React from 'react';

const IncidentList = () => {
  const incidents = [
    { id: 1, case: 'CR-1001', type: 'Robbery', status: 'Open', date: '2025-03-21' },
    { id: 2, case: 'CR-1002', type: 'Fraud', status: 'Investigating', date: '2025-03-20' },
    { id: 3, case: 'CR-1003', type: 'Assault', status: 'Closed', date: '2025-03-19' },
  ];

  return (
    <div>
      <h1 className="mb-6 text-2xl font-semibold">Incident List</h1>
      <table className="min-w-full overflow-hidden bg-white rounded-md shadow">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-6 py-3 font-medium text-left">Case</th>
            <th className="px-6 py-3 font-medium text-left">Type</th>
            <th className="px-6 py-3 font-medium text-left">Status</th>
            <th className="px-6 py-3 font-medium text-left">Date</th>
          </tr>
        </thead>
        <tbody>
          {incidents.map((incident) => (
            <tr key={incident.id} className="border-t">
              <td className="px-6 py-4">{incident.case}</td>
              <td className="px-6 py-4">{incident.type}</td>
              <td className="px-6 py-4">{incident.status}</td>
              <td className="px-6 py-4">{incident.date}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default IncidentList;

